import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import {
  DEFAULT_LOCALE,
  STORAGE_KEY,
  SUPPORTED_LOCALES,
  detectInitialLocale,
  type Locale,
} from './detect-locale'

export { SUPPORTED_LOCALES, DEFAULT_LOCALE, detectInitialLocale }
export type { Locale }
export {
  mapToSupportedLocale,
  readSystemLocale,
  readWebOSSystemLocale,
  readTizenSystemLocale,
  readPalmSystemLocale,
  extractWebOSUiLocale,
  readNavigatorLocale,
  readStoredLocale,
} from './detect-locale'

async function loadLocale(locale: Locale): Promise<Record<string, unknown>> {
  switch (locale) {
    case 'pt-BR':
      return (await import('./locales/pt-BR.json')).default as Record<string, unknown>
    case 'en-US':
      return (await import('./locales/en-US.json')).default as Record<string, unknown>
    case 'es-419':
      return (await import('./locales/es-419.json')).default as Record<string, unknown>
    default:
      return (await import('./locales/pt-BR.json')).default as Record<string, unknown>
  }
}

export async function setLocale(locale: Locale): Promise<void> {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, locale)
  }
  if (!i18n.hasResourceBundle(locale, 'translation')) {
    const bundle = await loadLocale(locale)
    i18n.addResourceBundle(locale, 'translation', bundle, true, true)
  }
  await i18n.changeLanguage(locale)
}

// Setup com lazy load de 1 bundle (do idioma detectado).
// Retorna Promise que resolve quando i18n está pronto pra renderizar.
export async function setupI18n(initial?: Locale): Promise<typeof i18n> {
  // detectInitialLocale é assíncrono: lê o locale do SISTEMA da TV (webOS Luna /
  // Tizen systeminfo) com timeout curto embutido. NUNCA pendura além do timeout.
  const lng = initial ?? (await detectInitialLocale())
  const bundle = await loadLocale(lng)

  await i18n.use(initReactI18next).init({
    resources: { [lng]: { translation: bundle } },
    lng,
    fallbackLng: DEFAULT_LOCALE,
    interpolation: { escapeValue: false },
  })
  return i18n
}

export { useTranslation, Trans } from 'react-i18next'
export { default as i18n } from 'i18next'
